/* Copyright 2021, Milkdown by Mirone. */
import { contextNotFound } from '@milkdown/exception';
export const createContainer = () => {
    const sliceMap = new Map();
    const getSlice = (slice) => {
        const context = sliceMap.get(slice.id);
        if (!context) {
            throw contextNotFound(slice.sliceName);
        }
        return context;
    };
    return { getSlice, sliceMap };
};
//# sourceMappingURL=container.js.map